/**
 * Reads the clinic an admin is ordering "as" (see ImpersonationContext.startClinicOrder). Sent
 * as ?clinic_id= on cart/order/payment-method calls so a staff/superuser can act for a clinic
 * directly, without impersonating one of its users - see
 * server/app/viewsets.py's resolve_impersonated_clinic() / resolve_effective_clinic(). Returns
 * null for every non-admin caller, and for an admin who isn't currently ordering for a clinic.
 *
 * Reads sessionStorage directly rather than the React context: this is called from plain API
 * modules (OrderApi, PaymentMethodApi) that sit outside any component tree, mirroring the
 * pattern ImpersonationContext itself already uses to persist across navigation.
 */
export const getImpersonatedClinicId = () => {
    const stored = sessionStorage.getItem('impersonatedClinic');
    if (!stored) {
        return null;
    }
    try {
        return JSON.parse(stored)?.id ?? null;
    }
    catch {
        return null;
    }
};
/**
 * Appends ?clinic_id=<id> to `baseUrl` when an admin is ordering for a clinic; otherwise
 * returns `baseUrl` unchanged. Assumes `baseUrl` has no existing query string, matching every
 * current call site.
 */
export const withClinicContext = (baseUrl) => {
    const clinicId = getImpersonatedClinicId();
    return `${baseUrl}${clinicId ? `?clinic_id=${clinicId}` : ''}`;
};
